import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Unstake your {asset}' },
  description: { defaultMessage: 'How much would you like to unstake?' },
  currentlyStaked: { defaultMessage: 'Currently staked' },
  unstake: { defaultMessage: 'Unstake' },
});
